import * as amplitude from "@amplitude/analytics-browser";
import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { RiMore2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { Glossary } from "src/components/Text/Glossary";
import { OrganizationError } from "src/hooks/useOrganization";
import * as Url from "src/services/url";
import * as GQL from "src/types/graphql";
import type { RemoteData } from "src/types/remoteData";

interface StudentListItemMenuProps {
  onDeleteStudentSuccess?: () => void;
  organization: RemoteData<OrganizationError, GQL.Organization>;
  person: GQL.GetStudentsByGuardianId_person;
}

export function StudentListItemMenu(props: StudentListItemMenuProps) {
  const { organization, person } = props;

  return (
    <>
      <Menu>
        <MenuButton
          aria-label="Options"
          as={IconButton}
          borderRadius="9999px"
          colorScheme="gray"
          icon={<RiMore2Fill />}
          variant="outline"
        />

        <MenuList maxWidth="260px">
          <MenuItem
            as={Link}
            to={organization
              .map((org) => Url.Parent.Form.new(org, { studentId: person.id }))
              .withDefault("#")}
            onClick={() => {
              amplitude.track("Start form clicked", {
                action_source: "student_list",
              });
            }}
          >
            <Glossary>Start form</Glossary>
          </MenuItem>

          <MenuItem
            as={Link}
            to={organization
              .map((org) => Url.Parent.Student.edit(org, person.id))
              .withDefault("#")}
          >
            <Glossary>Edit student</Glossary>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
